var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-div"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('v-alert',{attrs:{"dense":"","type":_vm.type || 'info',"dismissible":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }